<template>
  <div style="height: 100%; width: 100%; display: flex">
    <Navbar
      v-if="
        $route.fullPath != '/login' && $route.fullPath != '/login/registerpage'
      "
      :select-value="selectValue"
    />
    <div class="pagebox">
      <Header
        v-if="
          $route.fullPath != '/login' &&
          $route.fullPath != '/login/registerpage'
        "
      >
        <template #changebtn>
          <div class="iconsbox" @click="changeselectValueFn">
            <i v-if="selectValue" class="el-icon-s-fold big" />
            <i v-else class="el-icon-s-unfold big" />
          </div>
        </template>
      </Header>
      <div id="app">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectValue: true,
    }
  },
  name: 'defaulf-page',
  created() {
    // var _hmt = _hmt || []
  },
  mounted() {
    // var sc = document.createElement('script')
    // sc.src = 'https://player.polyv.net/script/polyvplayer.min.js'
    // var sList = document.getElementsByTagName('script')
    // var s = sList[sList.length - 1]
    // s.parentNode.insertBefore(sc, s)
  },
  methods: {
    changeselectValueFn() {
      this.selectValue = !this.selectValue
    },
  },
}
</script>
<style>
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
body {
  overflow: auto;
}
#app {
  height: 100%;
  width: 100%;
  height: calc(100% - 72px);
}
.pagebox {
  /* width: 100%; */
  flex: 1;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
}
.iconsbox {
  cursor: pointer;
}
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 5px;
}
::-webkit-scrollbar-track {
  background-color: white;
}
.el-slider__bar {
  background: #4a3aff;
}
.el-slider__button {
  border-color: #4a3aff;
}
.el-button--primary {
  background-color: #3f8cff;
  border-radius: 10px;
}
.el-dialog {
  border-radius: 10px;
}
.el-button--warning {
  background: #fdb11f;
  border-color: #fdb11f;
}
.el-button {
  border-radius: 4px;
  padding: 9px 18px;
}
.el-input__inner {
  border-radius: 6px;
  border-color: #d8e0f0;
}
.el-dialog__body {
  padding: 15px 20px;
  /* padding-right: 45px; */
  color: var(--textblack);
}
.el-message-box__status.el-icon-warning {
  color: var(--red);
}
.el-message-box__status {
  font-size: 18px !important;
}
.el-message-box__title {
  font-size: 16px;
  font-weight: 600;
}
.el-message-box__status + .el-message-box__message {
  padding-left: 25px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #3078ff;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-size: 16px;
}
.el-table tr {
  background-color: #f7fafc;
}
.el-dialog {
  min-width: 700px !important;
}
.el-dialog__title {
  font-weight: 600;
}
.el-form-item__label {
  color: var(--textblack);
}
.el-dialog__header {
  padding: 30px 60px 10px;
}
.el-dialog__body {
  padding: 10px 60px;
}
.el-form-item {
  margin-bottom: 15px;
}
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
</style>
